module.exports = __webpack_public_path__ + "img/meeting2.33ee3bc9.jpg";